import React from 'react';
import { Block, Icon } from '@/presentation/components';
import { GoToButton } from '@/presentation/components/Schedule/components/CourseDetail';
import { ArticuleBlock } from '@/presentation/modules/home/modules/InstitutionalInformationModule/styles';
import { ContainModel, TitleVisualMode } from './LateralPDF';
import ReusableButton from '@/presentation/reusables/Button';

interface PropsVisual {
  onClose: () => void;
  title: string;
  pdf?: boolean;
  onClickButton?: () => void;
}

const VisualModel = ({ onClose, title, pdf, onClickButton }: PropsVisual) => (
  <ArticuleBlock data-testid="cmp-visual-modal">
    <Block>
      <ContainModel>
        <TitleVisualMode>{title}</TitleVisualMode>
        <GoToButton
          padding="12px"
          margin="12px"
          buttonType="close"
          onClick={onClose}
        >
          <Icon name="x" size={22} />
        </GoToButton>
      </ContainModel>
      {pdf ? (
        <div>
          <p
            style={{
              padding: 16,
              fontSize: 14,
              textAlign: 'initial'
            }}
          >
            {
              'Declaro que la información brindada es ofrecida con pleno conocimiento y de forma libre, según lo establecido en la Ley N° 29733, Ley deProtección de Datos Personales y de su Reglamento. Asimismo, declaro haber sido informado sobre que mis datos personales serán tratados por la Universidad Tecnológica del Perú S.A.C ("UTP”), con R.U.C. N°20462509236, con domicilio en Calle Natalio Sánchez N° 125,Urbanización Santa Beatriz, distrito, provincia y departamento deLima, y almacenados en su banco de datos de "Alumnos UniversidadTecnológica del Perú (UTP)", para realizar las gestiones académicascorrespondientes en el marco de la relación entablada entre ambaspartes. Los datos personales solicitados son necesarios para elcumplimiento de la finalidad descrita; si no los brindo, la UTP nopodrá cumplir con las obligaciones adquiridas. Asimismo, las compañíaslistadas en el siguiente enlace podrán ser destinatarias de mis datospersonales en calidad de encargadas del tratamiento, siendoprincipalmente proveedores de servicios de software, alojamiento en lanube y procesamientos de datos, algunos de los cuales se encuentrafuera del Perú:[https://www.utp.edu.pe/politicasprivacidad/encargados-tratamiento].Mis datos personales serán conservados mientras se mantenga larelación jurídica, comercial, contractual, o de cualquier índole conla UTP, en tanto sea necesario para cumplir con las obligacioneslegales pertinentes y en atención al plazo de prescripción de posiblesreclamaciones previsto en el Código Civil. Podré ejercer los derechosde acceso, rectificación, cancelación y oposición a través del correoelectrónico arco@utp.edu.pe. De considerar que no he sido atendido enel ejercicio de mis derechos podré presentar una reclamación ante laAutoridad Nacional de Protección de Datos Personales, dirigiéndome ala Mesa de Partes del Ministerio de Justicia y Derechos Humanos: CalleScipion Llona 350, Miraflores, Lima, Perú, completando el siguienteformulario: https://bit.ly/49DIjy0. Para más información sobre nuestraPolítica de Privacidad, ingresar al siguiente enlace:https://www.utp.edu.pe/politicas-privacidad.'
            }
          </p>
          <ReusableButton
            style={{
              margin: 8
            }}
            onClick={onClickButton}
          >
            Empezar validación
          </ReusableButton>
        </div>
      ) : null}
    </Block>
  </ArticuleBlock>
);

export default VisualModel;
